import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, map, take } from 'rxjs';
import { selectAuthState } from '../../store/auth/auth.selectors';
import {citizenRouteNames} from '../../pages/citizen/citizen.routes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(selectAuthState).pipe(
      take(1),
      map(authState => {
        if (authState.isAuthenticated && authState.token) {
          return true;
        } else {
          this.router.navigate([citizenRouteNames.auth]);
          return false;
        }
      })
    );
  }
}
